import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html'
})
export class AccessDeniedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    console.log('Acces Denied');
  }

}
